// @flow
const PROPOSAL_DATA_UPDATE = "proposal/data/update";
const PROPOSAL_TIMEOUT = "proposal/timeout";
const PROPOSAL_DATA_CLEAR = "proposal/data/clear";
const PROPOSAL_ACCEPTED = "proposal/accepted";

export default {
    PROPOSAL_DATA_UPDATE,
    PROPOSAL_TIMEOUT,
    PROPOSAL_DATA_CLEAR,
    PROPOSAL_ACCEPTED
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/CurrentProposal/types.js